export default "__VITE_ASSET__DZA_XtPt__"